<template>
  <div class="sports_item_detail">
    <Empty description="加载中..." v-if="itemDetail == ''" />
    <div class="body" v-else>
      <mVideo
        :videoUrl="itemDetail.mediaurl"
        v-if="itemDetail.mediaurl"
        height="4rem"
        fit="contain"
      ></mVideo>
      <VanImage :src="itemDetail.icon" style="width: 7.5rem;height:3.75rem;" v-else></VanImage>
      <Panel class="header" :title="itemDetail.title">
        <CellGroup :border="false">
          <Cell title="开始时间" icon="clock-o">
            {{
            itemDetail.start_time
            }}
          </Cell>
          <Cell title="截止时间" icon="clock-o">{{ itemDetail.end_time }}</Cell>
          <Cell
            title="投票开始时间"
            v-if="itemDetail.type == 4 && itemDetail.vote_start_time"
            icon="clock-o"
          >{{ itemDetail.vote_start_time }}</Cell>
          <Cell
            title="投票截止时间"
            v-if="itemDetail.type == 4 && itemDetail.vote_end_time"
            icon="clock-o"
          >{{ itemDetail.vote_end_time }}</Cell>
          <Cell title="联系方式" icon="contact" v-if="itemDetail.contact && itemDetail.contact!=0">
            {{
            itemDetail.contact
            }}
          </Cell>
          <Cell
            title="活动规程"
            icon="todo-list-o"
            is-link
            v-if="itemDetail.rules"
            @click="show = true"
          ></Cell>
        </CellGroup>
      </Panel>

      <Popup v-model="show" closeable position="bottom" :style="{ height: '100%' }">
        <div class="vhtml" v-html="itemDetail.rules"></div>
      </Popup>

      <Panel title="要点" v-if="itemDetail.type != 4">
        <div
          v-html="itemDetail.content"
          class="vhtml"
          style="font-size: 14px;padding:.2rem .3rem .2rem;"
        ></div>
      </Panel>

      <rank-list v-if="itemDetail.type == 4" :item_sub_id="item_sub_id" :acid="acid"></rank-list>
      <CellGroup v-if="itemDetail.type != 4 && +itemDetail.total>0 && +acid" title="排行榜">
        <Cell is-link center title-class="join-list-title" @click="goRank">
          <div slot="title">
            {{ itemDetail.total }}
            <span style="font-size:12px;">人</span>
          </div>
          <div slot="label">已完成</div>
          <div v-if="joinList.length" class="joinuser">
            <template v-for="(item, index) in joinList.slice(0, 5)">
              <van-image
                v-if="item.avatarurl"
                :src="item.avatarurl"            
                :style="
                  `transform:translateX(${(joinList.slice(0, 5).length -
                    1 -
                    index) *
                    25}%)`
                "
              />
              <div v-else class="van-image" :style="
                {'transform':'translateX('+((joinList.slice(0, 5).length - 1 - index) * 25) + ')',background:filername(item.nickname)}">
                {{item.nickname.substr(0,1)}}
              </div>
            </template>
            
          </div>
        </Cell>
      </CellGroup>
    </div>
    <Footbar>
      <Cell slot="footbar">
        <Button
          v-if="itemDetail.today_state !== 1"
          round
          class="mvbutton"
          style="width: 100%;"
          block
          :disabled="itemDetail.disabled"
          :to="{ name: 'joinSports', params: this.$route.params }"
        >{{ itemDetail.tips }}</Button>
        <Button
          v-else
          round
          class="mvbutton"
          style="width: 100%;"
          block
          :to="{ name: 'sportsResult', params: this.$route.params }"
        >参赛详情</Button>
      </Cell>
    </Footbar>
  </div>
</template>

<script>
import moment from "moment";
import mVideo from "@/components/mVideo/index";
import Footbar from "@/components/footbar/index";
import rankList from "./rank";
import { Empty, Panel, Cell, Button, CellGroup, Image, Popup } from "vant";
import "./index.less";
import imgurl from "@/assets/img/common/default.png";
import util from 'libs/utils';
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    // ...mapGetters(["getOnlyUserInfo"]),
    imgurl() {
      return imgurl;
    },
  },
  filters: {
    
  },
  components: {
    mVideo,
    Empty,
    Panel,
    Cell,
    Button,
    CellGroup,
    Footbar,
    VanImage: Image,
    rankList,
    Popup,
  },
  data() {
    return {
      show: false,
      detail: "",
      itemDetail: "",
      joinList: [],
      matchid: '',
      item_sub_id: ''
    };
  },
  methods: {
    ...mapMutations(["toggleShowFill"]),
    filername(name){
      let val = util.hc(name,6)
      console.log(val)
      switch(val*1){
        case 0:
          return '#B9C5D1';
        case 1:
          return '#D2C1B9';
        case 2:
          return '#BAB3C6';
        case 3:
          return '#D3BFC8';
        case 4:
          return '#D0CAB2';
        case 5:
          return '#B6C3B2';
      }
    },
    goRank() {
      // :to=""
      this.$router.push({ name: "sportsRank", params: this.$route.params, query: {rank_type: this.itemDetail.rank_type} });
    },
    openImg(url) {
      wx.previewImage({
        current: "", // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      });
    },
    init: function () {
      this.$toast.loading({
        duration: 0,
      });
      let params = { cpgid: this.item_sub_id };
      this.$api.sports.getComparegame(params).then(
        (res) => {
          this.joinList = Object.assign([], res.data.list);
          delete res.data.list;
          let { start_time, end_time, sex_limit, age_limit } = res.data;
          start_time = moment(start_time).valueOf();
          end_time = moment(end_time).valueOf();
          var sys_time = res.sys_time * 1000;
          let tips,
            disabled = true;
          if (sys_time < start_time) {
            tips = "活动未开始";
          } else if (sys_time > end_time) {
            tips = "活动已结束";
          } else {
            tips = "立即参与";
            disabled = false;
          }
          this.itemDetail = Object.assign(res.data, { tips, disabled });
          this.$toast.clear();
        },
        () => {
          this.$toast.clear();
        }
      );
    },
  },
  mounted() {
    this.item_sub_id = this.$route.params.item_sub_id
    this.acid = this.$route.params.acid
    this.init();
    this.cf.wxShareConf();
  },
};
</script>

<style scoped>
.html >>> img {
  max-width: 100%;
}

.img-area {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-area img {
  max-width: 100%;
}
</style>
